import React from "react";
import ImDownloadCollapsePanel from "./ImDownloadPanel";
import ImUploadBox from "./ImUploadPanel";
import "./index.less";

const ImCollapsePanel = (props: any) => {
  const { gid } = props;
  return (
    <div className="joyspace-group-collapse">
      {/* <ImUploadBox gid={gid} /> */}
      <ImDownloadCollapsePanel gid={gid} className="joyspace-download" />
    </div>
  );
};

export default ImCollapsePanel;
